
import { Grid } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { DisenioCentroCosto } from "../../layout";
import { TarjetasOpciones } from "../../components";





export const OpcionesCentroCosto = () => {


    const { id } = useParams();
    const navigate = useNavigate();

    
    const handleNavegar = (url) => {
        navigate(`/admin/cencos/${id}/${url}`)
    }



    const data = [
        {key:1, titulo:'Editar Centro Costo', function: handleNavegar, url:'add', icono:'setting'},
        {key:2, titulo:'Entradas', function: handleNavegar, url:'entradas', icono:'entradas'},
    ];



    return (

        <DisenioCentroCosto titulo="Opciones de Centro de Costo" url={1}>
            <Grid container spacing={3} sx={{mt:1}}>
                {data.map( item => (
                    <Grid key={item.key} item xs={6} sm={4} md={3} lg={2.4}>
                        <TarjetasOpciones
                            onClickHandler={item.function} 
                            url={item.url} 
                            icono={item.icono} 
                            titulo={item.titulo} 
                        />
                    </Grid>
                ))}
            </Grid>
        </DisenioCentroCosto>

    )
}
